var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container"},[_c('md-dialog',{attrs:{"md-active":_vm.localShowDialog},on:{"update:mdActive":function($event){_vm.localShowDialog=$event},"update:md-active":function($event){_vm.localShowDialog=$event}}},[_c('md-dialog-actions',[_c('div',{staticClass:"map-img"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }